export default __webpack_public_path__ + "images/Large-icon-Success.png";